// @flow

import LocationMap from './location-map'

export default LocationMap
